import React, { Component }      from 'react'
import {connect}                 from 'react-redux';
import moment                    from 'moment';
import {GetDesempendoAtividade } from '../../../actions/atividadesAction';
import FlashRetornoNulo          from '../../../container/FlashRetornoNulo';
import FlashCarregando           from '../../../container/FlashCarregando';
import { SetError }              from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo}    from '../../../actions/scopoAction';

class Desempenho extends Component {

    constructor(props){
 
        super(props);
        this.state = {
                        ati_id : this.props.match.params.id,
                        lista  : [],
                        load   : false
                     }
    }
    
    componentWillMount(){
       
        this.props.GetDesempendoAtividade(this.state.ati_id).then( (response) =>{
            this.setState({load:true})
        }).catch( (error) => {
            this.props.SetError(500);
        });


        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.batalha.nomeModulo,link:this.props.menu.desafios.home},
            {action:false,nome:"Alunos"},
           ]);

          this.props.GetListaSubMenuTopo([]);

    } 

    renderDesempenhoAluno(){

          const listaAlunoDesempenho = this.props.desempenhoAluno;  
          if (listaAlunoDesempenho.length) {
                return listaAlunoDesempenho.map((elem,i) =>{
                    const data = (elem.data_tentativa !== "-"? moment(elem.data_tentativa).format("DD/MM/YYYY"):"-");
                    return  <tr key={i}>
                                <td className="text-center">{elem.use_nome}</td>
                                <td className="text-center hidden-xs">{elem.tentativas}</td>
                                <td className="text-center hidden-xs">{data}</td>
                                <td className="text-center ">{elem.pontos}</td>
                            </tr>;
                });

           }else{
                return <tr> <td colSpan={4} className="text-center"><FlashRetornoNulo/></td></tr>;
            }
    }   

    render () {
        
        if(!this.state.load) {
            return  <FlashCarregando/>;
        }
       
        return (
          
            <div className="container-bg">
                    <div className="panel panel-azul-claro panel-cinza">
                        <div className="panel-body">
                        <table className="table table_panel">
                            <thead> 
                                <tr> 
                                    <th className="text-center">Nome Aluno</th> 
                                    <th className="text-center hidden-xs">Tentativas</th> 
                                    <th className="text-center hidden-xs">Último Jogo</th> 
                                    <th className="text-center">Nota</th> 
                                </tr> 
                            </thead> 
                            <tbody> 
                                 {this.renderDesempenhoAluno()}
                            </tbody> 
                        </table>
                    </div>
                </div>          
            </div>
        )
    }
}

function mapStateToProps(state){

    return {
      session         : state.auth.session,
      menu            : state.configReducer.menu,
      desempenhoAluno : state.atividadesReducer.allDesempenhoAluno

    };
  }

export default connect(mapStateToProps,{ GetDesempendoAtividade,
                                         GetListaMenuTopo,
                                         GetListaSubMenuTopo,
                                         SetError
                                        })(Desempenho);


// WEBPACK FOOTER //
// ./src/components/professor/desafios/desafios_desempenho_aluno.js